<template>
  <div>
    <p>jkfkkfk</p>
    <stripe-element-payment
      ref="paymentRef"
      :pk="pk"
      :elements-options="elementsOptions"
      :confirm-params="confirmParams"
    />
    {{ elementsOptions.clientSecret }}
    <button @click="pay">Pay</button>
  </div>
</template>

<script>
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
import WalletRequest from "@/model/requests/WalletRequest";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
export default {
  name: "PaymentView",
  components: { StripeElementPayment },
  data() {
    return {
      pk:
        "pk_test_51Lj0x3JcyYCn3q9QbeEobfo3eyR00inVXqJeWoElFzDhrOdeQExhuFqVuG0K3pNTJs5GJaJGx3Mb72l57VBvNS9W00xIzradVN",
      elementsOptions: {
        appearance: { theme: "stripe" }
      },
      confirmParams: {
        return_url: "https://localhost:8080/customer-dashboard" // success url
      },
      payModel: WalletRequest.createPaymentIntent
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
      // paymentIntent: state => state.wallet.paymentIntent
    }),
    paymentIntent() {
      return StoreUtils.rootGetters("wallet/getPaymentIntent");
    }
  },
  methods: {
    createPaymentIntent() {
      // this.payModel.customerStripeId = this.userInfo.customerStripeId;
      StoreUtils.dispatch("wallet/createPaymentIntent", this.payModel);
      this.elementsOptions.clientSecret = this.paymentIntent.client_secret;
    },
    pay() {
      // this.$refs.paymentRef.redirectToPayment();
      this.$refs.paymentRef.submit();
    }
  }
};
</script>

<style scoped></style>
